import { Parametro } from "app/types/Parametro"
import { IProduto } from "app/types/produto/IProduto"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import { Dict } from "app/utils/Dict"
import * as R from "ramda"
import React, { useEffect, useRef, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { CompararProdutos } from "./CompararProdutos"


export type CompararProdutosContainerProps = {
    itens: IProduto[]
    onVoltar: () => void,
    passos: Dict<string, () => void>
    regiaoRenderizada: string
}

export const CompararProdutosContainer = (props: CompararProdutosContainerProps) => {
    const [parametros, setParametros] = useState<Parametro[]>([]);


    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const atualizarValoresParametros = async () => {
        await R.pipe(
            () =>
                obterParametros({
                    nomes: [
                        "EXIBIR_QUANTIDADE_ESTOQUE_CONSULTA_PRODUTOS",
                        "EXIBIR_PRECO_COMISSAO_NA_CONSULTA_PRODUTOS",
                        "EXIBIR_QUANTIDADE_MINIMA_VENDA_CONSULTA_PRODUTOS"
                    ],
                }),
            R.andThen(setParametros)
        )();
    };

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    const onPassoSelecionado = (passo: string) => {
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onVoltar()
    }

    useEffect(() => {
        passosInterno.current.set("Comparar Produtos", () => { })
        atualizarValoresParametros();
        window.scrollTo(0, 0)
    }, []);


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                id="Comparar_ProdutosContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <CompararProdutos
                dadosCompararProdutos={props.itens}
                exibirQuantidadeEstoque={valorParametro("EXIBIR_QUANTIDADE_ESTOQUE_CONSULTA_PRODUTOS") == "S"}
                exibirQuantidadeMinimaVenda={valorParametro("EXIBIR_QUANTIDADE_ESTOQUE_CONSULTA_PRODUTOS") != "N"}
                exibirComissaoVenda={valorParametro("EXIBIR_PRECO_COMISSAO_NA_CONSULTA_PRODUTOS") != "N"}
            />
        </>

    )

}